<!-- Floating Button -->
<div class="accessibility-fab"
  (click)="togglePanel($event)"
  [title]="panelOpen ? 'Close Accessibility' : 'Open Accessibility'">

  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="white" viewBox="0 0 24 24"  aria-label="Accessibility icon">
    <path d="M12 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm8 4.5l-5 .5 .5 4 3 1-1 1-3-1-.5 6.5h-1L13 12h-2l-.5 6.5h-1L9 13l-3 1-1-1 3-1 .5-4-5-.5v-1.5l5 .5h8l5-.5V6.5z"/>
    <title>Accessibility</title>
  </svg>
</div>

<!-- Panel -->
@if (panelOpen) {
  <div class="accessibility-panel shadow" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="panel-header">
      <span class="panel-title">Accessibility</span>
      <button type="button" class="close-btn" (click)="closePanel($event)">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
    <!-- Grid Buttons -->
    <div class="panel-grid">
      <!-- <button class="feature-card"
      [class.active]="accessibility?.isSpeaking"
      (click)="accessibility?.toggleScreenReader()">
      <div class="feature-icon">
        <i class="bi"
        [ngClass]="accessibility?.isSpeaking ? 'bi-stop-circle-fill' : 'bi-volume-up-fill'"></i>
      </div>
      <span class="feature-label">
        {{ accessibility?.isSpeaking ? 'Stop Reader' : 'Screen Reader' }}
      </span>
    </button> -->
    <button class="feature-card"
      [class.active]="fontService.isSpeaking"
      (click)="toggleScreenReader()">
      <div class="feature-icon">
        <i class="bi"
          [ngClass]="fontService.isSpeaking ? 'bi-stop-circle-fill' : 'bi-volume-up-fill'">
        </i>
      </div>
      <span class="feature-label">
        {{ fontService.isSpeaking ? 'Stop Reader' : 'Screen Reader' }}
      </span>
    </button>
    <button class="feature-card"
      [class.active]="highContrast"
      (click)="toggleContrast()">
      <div class="feature-icon">
        <i class="bi bi-circle-half"></i>
      </div>
      <span class="feature-label">Smart Contrast</span>
    </button>
  </div>
  <!-- Bigger Text -->
  <div class="panel-section">
    <div class="section-label-row">
      <span class="tt-small">T</span>
      <span class="tt-big">T</span>
      <span class="section-label">Bigger Text</span>
    </div>
    <div class="slider-track-wrapper">
      <input type="range"
        class="font-slider"
        min="-3" max="3" step="1"
        [value]="fontService.fontStep || 0"
        (input)="onFontChange($event)" />
        <div class="slider-dots">
          @for (i of [1,2,3,4,5,6,7]; track i; let idx = $index) {
            <span
              class="dot"
              [class.filled]="idx - 3 <= (fontService.fontStep)">
            </span>
          }
        </div>
      </div>
    </div>
    <!-- Theme -->
    <div class="panel-section">
      <div class="section-label">Theme</div>
      <div class="theme-circles">
        @for (t of themes; track t) {
          <button
            class="theme-dot"
            [class.selected]="accessibility?.theme === t.value"
            [ngStyle]="{'background': t.bg, 'border': '2px solid ' + t.border}"
            (click)="setTheme(t.value)"
            [title]="t.label">
          </button>
        }
      </div>
    </div>
    <button class="reset-btn" (click)="resetAll()">Reset All</button>
  </div>
}